import React from 'react';
import { Overlay, Spinner } from '@enterprise-ui/canvas-ui-react';

// eslint-disable-next-line no-unused-vars
var ProgressOverlay = function ProgressOverlay(_ref) {
  var inProgress = _ref.inProgress;
  return /*#__PURE__*/React.createElement(Overlay, {
    type: "subtle",
    isVisible: inProgress
  }, /*#__PURE__*/React.createElement("div", {
    className: "centering-container"
  }, /*#__PURE__*/React.createElement(Spinner, {
    size: "expanded"
  })));
};

export { ProgressOverlay as default };
